var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { SkuCommodityCode } from "./SkuCommodityCode";
export class UpdateSku {
  constructor(_data) {
    /**
     */
    __publicField(this, "CommodityCodes");
    /**
     */
    __publicField(this, "ItemIdentifier");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof UpdateSku
     */
    __publicField(this, "$type", "V1.ComplianceMasterData.UpdateSku");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["CommodityCodes"] && _data["CommodityCodes"].constructor === Array) {
        this.CommodityCodes = [];
        for (let item of _data["CommodityCodes"]) {
          const commodityCodes_ = new SkuCommodityCode();
          this.CommodityCodes.push(commodityCodes_.init(item));
        }
      }
      this.ItemIdentifier = _data["ItemIdentifier"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["$type"] = this.$type;
    if (this.CommodityCodes && this.CommodityCodes.constructor === Array) {
      _data["CommodityCodes"] = [];
      for (let item of this.CommodityCodes) {
        _data["CommodityCodes"].push(item.toJSON());
      }
    }
    _data["ItemIdentifier"] = this.ItemIdentifier;
    return _data;
  }
}
